import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form, Input, Alert, Typography, Divider } from 'antd';
import { useTranslation } from 'react-i18next';
import { POST } from '../../utils/HttpClient';
import { Toast } from '../../utils/Toast';
import { URL_AUTH } from '../../constance/urls';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';

const { Title } = Typography;

export default function ChangePasswordModal(props) {
  const { open, onClose } = props;
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessages, setErrorMessages] = useState(null);

  const [form] = Form.useForm();

  const handleSubmit = async (values) => {
    setIsLoading(true);
    setErrorMessages(null);

    try {
      await POST(URL_AUTH.CHANGE_PASSWORD, values);
      Toast.success(t('success'));
      onClose();
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      title={<Typography.Title level={4}>{t('user_profiles.change_password')}</Typography.Title>}
      open={open}
      onCancel={onClose}
      footer={null}
      centered={false}
    >
      {errorMessages && (
        <Alert
          message={t('error')}
          description={errorMessages}
          type="error"
          showIcon
          style={{ marginBottom: '16px' }}
        />
      )}
      <Divider />
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{ new_password: '' }}
      >
        <Form.Item
          label={t('user_profiles.new_password')}
          name="new_password"
          rules={[
            {
              required: true,
              message: t('error_messages.validation.required'),
            },
          ]}
        >
          <Input.Password placeholder={t('user_profiles.new_password')} />
        </Form.Item>
        <Divider dashed />
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1em' }}>
          <Button
            color="default"
            variant="filled"
            onClick={onClose}
            icon={<CloseOutlined />}
            style={{ fontWeight: 600 }}
          >
            {t('cancel')}
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={isLoading}
            icon={<CheckOutlined />}
          >
            {t('confirm')}
          </Button>
        </div>
      </Form>
    </Modal>
  );
}

ChangePasswordModal.defaultProps = {
  open: false,
  onClose: () => null,
};

ChangePasswordModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};